export * from './scheduleEvent/cycles';

export const DealBannerConstants = {
    v1: 'ctdnt',
    v2: 'CDTv2',
    minutes: 20,
};

export const leadSourceOptions = [
    {
        name: 'Choose one...',
        value: null,
    },
    {
        name: 'Google',
        value: 'google',
    },
    {
        name: 'Yelp',
        value: 'yelp',
    },
    {
        name: 'Facebook',
        value: 'facebook',
    },
    {
        name: 'Twitter',
        value: 'twitter',
    },
    {
        name: 'Thumbtack',
        value: 'thumbtack',
    },
    {
        name: 'Nextdoor',
        value: 'nextdoor',
    },
    {
        name: 'Email',
        value: 'email',
    },
    {
        name: 'Billboard',
        value: 'billboard',
    },
    {
        name: 'Direct Mail',
        value: 'direct mail pieces',
    },
    {
        name: 'Radio',
        value: 'radio',
    },
    {
        name: 'Press',
        value: 'press',
    },
    {
        name: 'Friend/Family',
        value: 'word of mouth',
    },
    {
        name: 'Yard Sign',
        value: 'yard sign',
    },
    {
        name: 'Other',
        value: 'other',
    },
];

// instant quotes
export const serviceIdToInstantQuote = {
    8: {
        type: 'instant_quote_bush_trimming',
        dummyId: 'dummyBushId',
        endpointSuffix: 'bush-trimmings',
    },
    10: {
        type: 'instant_quote_leaf_removal',
        dummyId: 'dummyLeafId',
        endpointSuffix: 'leaf-removals',
    },
};

export const serviceIds = {
    TREATMENT: 2,
    FERTILIZATION: 2188,
    AERATION: 5,
    AERATION_OVERSEEDING: 17,
    LEAF_REMOVAL: 10,
    BUSH_TRIMMING: 8,
    BED_WEEDING: 170,
    MOSQUITO: 4599,
};

export const serviceType = {
    MOWING: 'mowing',
    TREATMENT: 'treatment',
};

export const INTENT_KEY = 'intent';

export const FAQ_TREATMENT_QUESTIONS = [
    {
        key: 'whenStart',
        title: 'When should I start treatment?',
        content:
            'For best results, we currently offer and recommend a year-round treatment for comprehensive fertilization and weed control. This is a reoccurring service, every 4-6 weeks. Our pro will customize your service to your lawn needs on each treatment.',
    },
    {
        key: 'whenFirstService',
        title: 'When is the first service?',
        content:
            'Your Lawn Treatment will occur within a three week window starting on your selected date. Each service will be scheduled about 4-6 week apart. Check in-app for the next service.',
    },
    {
        key: 'canCancel',
        title: 'Can I cancel anytime?',
        content:
            'You can cancel anytime. You are never charged until after the service is completed. However, our pros recommend at least 8 treatments to see the best results.',
    },
];
